// ============================================================
// Datei: src/components/Toast.jsx
// Zweck: Wiederverwendbare Festival-Dark-Glass Toast-Meldung
//
// 🔥 ÄNDERUNGEN:
// - NEUER TYPE: "warning"
// - ORANGE Titel + Styling
// - bestehende Logik UNVERÄNDERT
// ============================================================

import React, { useEffect } from "react";
import "../styles/toast.css";

/**
 * @param message  Text der Meldung
 * @param onClose  Callback zum Schliessen
 * @param type     "success" | "error" | "info" | "warning"  🔥 NEU
 * @param duration Anzeigezeit in ms
 */
const Toast = ({ message, onClose, type = "success", duration = 1800 }) => {

    // ============================================================
    // AUTO CLOSE
    // ============================================================
    useEffect(() => {
        const timer = setTimeout(onClose, duration);
        return () => clearTimeout(timer);
    }, [onClose, duration]);

    // ============================================================
    // 🔥 TITLE LOGIK (NEU: warning)
    // ============================================================
    const getTitle = () => {
        switch (type) {
            case "success":
                return "✨ Erfolgreich ✨";
            case "error":
                return "⚠️ Fehler";
            case "warning":
                return "⚠️ Hinweis";
            case "info":
            default:
                return "ℹ️ Hinweis";
        }
    };

    return (
        <div className={`toast toast-${type}`}>
            <div className="toast-title">
                {getTitle()}
            </div>

            <div className="toast-message">
                {message}
            </div>
        </div>
    );
};

export default Toast;